// eslint-disable-next-line import/no-extraneous-dependencies
import { useState } from 'react';
// Wanted to use a ref, but the input doesn't take a ref
// unless we use our own input, which makes us lose some of the built-in stuff we want.
export default function useTrackFocused(options) {
    var _a = useState(false), isFocused = _a[0], setFocused = _a[1];
    return {
        isFocused: isFocused,
        onFocus: function () {
            setFocused(true);
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            (options === null || options === void 0 ? void 0 : options.onFocus) && options.onFocus();
        },
        onBlur: function () {
            setFocused(false);
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            (options === null || options === void 0 ? void 0 : options.onBlur) && options.onBlur();
        },
    };
}
